import axios from "axios";
import { GET_LOCAL } from "../Models/LocalData";

const axiosConfig = axios.create({
  baseURL: process.env.REACT_APP_API,
});

// Also add/ configure interceptors && all the other cool stuff
axiosConfig.interceptors.request.use((config) => {
  const authToken = GET_LOCAL("login_data")?.accesstoken;
  if (authToken) config.headers.Authorization = `Bearer ${authToken}`;
  return config;
});

export default axiosConfig;
